'use strict';
(function() {
	angular.module('onboarding.services')
		.factory('internalAdminService', internalAdminService);

	internalAdminService.$inject = ['$http'];

	function internalAdminService($http) {

		return {
			defineOnboardingBroker: defineOnboardingBroker,
			identifyBroker: identifyBroker,
			getBrokers: getBrokers,
			getBrokerUsageReport: getBrokerUsageReport,
			getCarriers: getCarriers,
			searchCarriers: searchCarriers,
			processTinFile: processTinFile,
			getAssureSignContracts: getAssureSignContracts,
			updateContractTemplateId: updateContractTemplateId,
			updateTinStatus: updateTinStatus
		};

		function identifyBroker(domain) {
			return $http.get('/api/internaladmin/identifyBroker', { params: { domain: domain } });
		}

		function getBrokers(request) {
			return $http.get('/api/internaladmin/brokers', request);
		}

		function getCarriers(request) {
			return $http.get('/api/internaladmin/carriers', request);
		}

		function searchCarriers(searchType, searchTerm, startRow, rowCount, includeRowCount) {
			return $http.get('/api/internaladmin/searchcarriers',
				{
					params: {
						searchType: searchType,
						searchValue: searchTerm,
						currentRow: startRow,
						rowCount: rowCount,
						includeRowCount: includeRowCount
					}
				});
		}

		function defineOnboardingBroker(request) {
			return $http.put('/api/internaladmin/defineBroker', request);
		}

		function processTinFile(request) {
			return $http.post('/api/internaladmin/processTinFile', request);
		}

		function getAssureSignContracts() {
			return $http.get('/api/internaladmin/assuresigncontracts');
		}

		function updateContractTemplateId(brokerId, contractId, templateId, contractName) {
			var request = {
				brokerId: brokerId,
				contractId: contractId,
				templateId: templateId,
				contractName: contractName
			};

			return $http.put('/api/internaladmin/updateContractTemplate', request);
		}

		function getBrokerUsageReport() {
			return $http.get('/api/internaladmin/brokerUsageReport', { params: {} });
		}

		function updateTinStatus(request) {
			return $http.put('/api/internaladmin/updateTinStatus', request);
		}
	}
})();
